<script setup lang="ts">
const props = defineProps<{ place: 'social' | 'register' }>()
const t2 = useT2({
  'If signing in creates a new account, you agree to the': 'Jei prisijungiant bus sukurta nauja paskyra, sutinkate su',
  'By creating an account, you agree to the': 'Kurdami paskyrą sutinkate su',
  'Terms of Use': 'Naudojimosi taisyklėmis',
  termsTitle: { en: 'Terms of Use', lt: 'Naudojimosi taisyklės' },
  'and confirm that you have read the': 'ir patvirtinate, kad susipažinote su',
  'Privacy Policy': 'Privatumo politika',
})

const { linkPrivacy, linkTerms } = useLinks()
const { seller } = useSeller('browser')
const intro = computed(() => {
  if (props.place === 'social') return t2('If signing in creates a new account, you agree to the')
  return t2('By creating an account, you agree to the')
})
</script>

<template>
  <div class="_relative _fs09 _lh12 _fw-l _ls-xs _c2">
    <span class="_txt_inline">{{ intro }}&nbsp;</span>
    <AuthLink :txt="t2('Terms of Use')" class="_cb3" :to="linkTerms()" :document-id="seller?.doc?.termsAndConditions?._id" :modal-title="t2('termsTitle')" />
    <span class="_txt_inline">&nbsp;{{ t2('and confirm that you have read the') }}&nbsp;</span>
    <AuthLink :txt="t2('Privacy Policy')" class="_cb3" :to="linkPrivacy()" :document-id="seller?.doc?.privacyPolicy?._id" :modal-title="t2('Privacy Policy')" />.
  </div>
</template>
